import React, {createContext, useContext, useState, useEffect} from 'react'

# Global translation cache: {cacheKey: {hash: translatedText}}
translationCache = {}

TranslationContext = createContext({
  translations: {}
  locale: 'en'
  loading: false
})

export TranslationProvider = ({children, route, app}) ->
  [translations, setTranslations] = useState({})
  [locale, setLocale] = useState(window.i18nManager?.getLocale() || 'en')
  [loading, setLoading] = useState(false)

  # Fetch translations for current route with caching
  useEffect ->
    # The authored text needs no fetch — and 'en-US' is not 'en' (card 6aa6c738).
    return if window.i18nManager?.readsSource(locale) ? true

    # Check cache first
    cacheKey = "#{locale}:#{app}:#{route}"
    if translationCache[cacheKey]?
      # console.log "✅ Using cached translations for #{cacheKey}"
      setTranslations(translationCache[cacheKey])
      return

    # Not in cache - fetch from server
    # Skip if no clientAPI (using localStorage + upsertBatch caching instead)
    return if !window.clientAPI?.i18nString?

    # console.log "📡 Fetching translations for #{cacheKey}"
    setLoading(true)
    window.clientAPI.i18nString.find({
      where: {app: app, route: route}
    }).then (strings) ->
      # Build translation map
      translationMap = {}
      for string in strings
        # Server already translated 'text' field via applyTranslations()
        translationMap[string.hash] = string.text

      # Store in TranslationProvider cache
      translationCache[cacheKey] = translationMap
      setTranslations(translationMap)

      # CRITICAL: Also update window.i18nTranslationCache (used by jsxFactory)
      # Merge with existing cache instead of replacing
      window.i18nTranslationCache ?= {}
      for hash, text of translationMap
        window.i18nTranslationCache[hash] = text

      # console.log "✅ Updated global cache with #{Object.keys(translationMap).length} translations"

      setLoading(false)
    .catch (err) ->
      console.error "Failed to load translations:", err
      setLoading(false)
  , [route, locale, app]

  # Listen for locale changes from i18nManager
  useEffect ->
    return unless window.i18nManager?

    handler = (newLocale) ->
      setLocale(newLocale)
      setTranslations({})  # Clear component state

      # Clear global cache to force refetch with new locale
      window.i18nTranslationCache = {}
      console.log "🔄 Locale changed to #{newLocale} - cleared global cache"

    window.i18nManager.on 'localeChanged', handler
    return -> window.i18nManager.off 'localeChanged', handler
  , []

  React.createElement TranslationContext.Provider, {value: {translations, locale, loading}}, children

export useTranslation = ->
  useContext(TranslationContext)

# Clear cache (useful for dev/testing)
export clearTranslationCache = ->
  translationCache = {}
